"use client";

import { FileUploader, FileInput, FileUploaderContent, FileUploaderItem } from "../ui/file-uploader";
import { useState } from "react";
import { DropzoneOptions } from "react-dropzone";
import { Button } from "../ui/button";
import { LoadingSmall } from "../LoadingSmall";
import { useTranslation } from "react-i18next";

interface Props {
  onClickUpload: (files: File[]) => void;
  isLoading?: boolean;
  dropZoneContent?: React.ReactNode;
  dropzoneOptions: DropzoneOptions;
  children?: React.ReactNode;
}

export const FileUploadDropzone: React.FC<Props> = ({ onClickUpload, isLoading, dropZoneContent, dropzoneOptions }) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState<File[] | null>([]);
  const supportMultipleFiles = dropzoneOptions.maxFiles && dropzoneOptions.maxFiles > 1;

  return (
    <>
      <FileUploader value={files} onValueChange={setFiles} dropzoneOptions={dropzoneOptions} orientation="vertical">
        <FileInput>
          {dropZoneContent || (
            <div className="flex items-center justify-center h-16 w-full border bg-background rounded-md">
              <p className="text-gray-400">
                {supportMultipleFiles ? t("fileUpload.dropzone.files") : t("fileUpload.dropzone.file")}
              </p>
            </div>
          )}
        </FileInput>
        <FileUploaderContent>
          {files?.map((file, i) => (
            <FileUploaderItem
              key={i}
              index={i}
              className="w-20 h-20 size-20 p-0 rounded-md overflow-hidden"
              aria-roledescription={`file ${i + 1} containing ${file.name}`}
            />
          ))}
        </FileUploaderContent>
      </FileUploader>
      {files?.length ? (
        <Button onClick={() => onClickUpload(files || [])} disabled={files?.length === 0 || isLoading} className="mt-4">
          {t("fileUpload.dropzone.button")} {isLoading && <LoadingSmall />}
        </Button>
      ) : null}
    </>
  );
};
